import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";

const TestForPackage = ({ isOpen, onRequestClose, packageId }) => {
    const [loader, setLoader] = useState(false);
  
  const [testDetails, setTestDetails] = useState([]);
const navigate = useNavigate();
   const getData = async () => {
      setLoader(true);
      try {
        const token = JSON.parse(localStorage.getItem("data")).token;
        const response = await axios.get(
          `/api/packagetestmapping/packageid=${packageId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setTestDetails(response.data);
        setLoader(false);
      } catch (error) {
        setLoader(false);
       handleError(error);
      }
    };

     function handleError(error) {
        if (error.response) {
          if (error.response.status === 401) {
            navigate(`/signin`);
            toast.error("Your session has expired. Please login.");
          } else if (error.response.data && error.response.data.message) {
            toast.error(error.response.data.message);
          }  else if (error.response.data && error.response.data.code) {
            toast.error(error.response.data.code);
          }
           else {
            toast.error("An error occurred.");
          }
        } else if (error.message) {
          toast.error(error.message);
        } else {
          toast.error("An error occurred.");
        }
      }
    
    
    
  useEffect(() => {
   getData();
  }, [packageId]);

  return (
    <>
     {loader && <div className="loading"></div>}
      <Modal show={isOpen} onHide={onRequestClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Tests Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <p>
            Package Name: <strong>{testDetails[0]?.pac?.packagename}</strong>
            </p>
            <ul>
              {testDetails.map((test) => (
                <li key={test.id}>
                  {test.lab?.testCat?.categoryname} : <strong>{test.lab?.testname}</strong>
                </li>
              ))}
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onRequestClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TestForPackage;
